module.exports = __webpack_public_path__ + "static/img/amg-energia-2.87f0513.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/amg-energia-2.jpg
// module id = SvFz
// module chunks = 1